import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Tabs, TabsStrategy } from '../../components/Tabs';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_DOCUMENT_TEMPLATES,
  PATH_SECTION_TEMPLATES,
  PATH_DOCUMENT_AND_SECTION_TEMPLATES_DEFAULT,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { DocumentTemplatesTabPanel } from './DocumentTemplates';
import { SectionTemplatesTabPanel } from './SectionTemplates';

export const DocumentAndSectionTemplatesPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.DocumentAndSectionTemplates);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Modèles')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_DOCUMENT_AND_SECTION_TEMPLATES_DEFAULT,
            label: 'modèles',
            key: 'templates',
          },
        ]}
      />
      <PageTitle title="Liste des Modèles" />
      <Tabs
        id="document-and-section-templates-tabs"
        strategy={TabsStrategy.RouterConnected}
        tabs={[
          {
            key: 'documentTemplates',
            label: 'Modèles de Documents',
            panel: <DocumentTemplatesTabPanel />,
            to: PATH_DOCUMENT_TEMPLATES,
          },
          {
            key: 'sectionTemplates',
            label: 'Modèles de Sections',
            panel: <SectionTemplatesTabPanel />,
            to: PATH_SECTION_TEMPLATES,
          },
        ]}
        title="Onglets de l'écran de Liste des Modèles"
      />
    </>
  );
};
